import { render, staticRenderFns } from "./McGasha.vue?vue&type=template&id=807bb1de&scoped=true&"
import script from "./McGasha.vue?vue&type=script&lang=js&"
export * from "./McGasha.vue?vue&type=script&lang=js&"
import style0 from "./McGasha.vue?vue&type=style&index=0&id=807bb1de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807bb1de",
  null
  
)

export default component.exports